/*
 *
 * anjiman constants
 *
 */
export const TOAST_ERROR = "app/TOAST_ERROR";
export const TOAST_SUCCESS = "app/TOAST_SUCCESS";
export const TOAST_WARNING = "app/TOAST_WARNING";

export const GET_SCHOOL_DETAIL_REQUESTED = "anjoman/GET_SCHOOL_DETAIL_REQUESTED";
export const GET_SCHOOL_DETAIL_SUCCESS = "anjoman/GET_SCHOOL_DETAIL_SUCCESS";
export const GET_SCHOOL_DETAIL_FAILED = "anjoman/GET_SCHOOL_DETAIL_FAILED";

export const GET_ADD_ABLE_MEMBER_LIST_REQUESTED = "anjoman/GET_ADD_ABLE_MEMBER_LIST_REQUESTED";
export const GET_ADD_ABLE_MEMBER_LIST_SUCCESS = "anjoman/GET_ADD_ABLE_MEMBER_LIST_SUCCESS";
export const GET_ADD_ABLE_MEMBER_LIST_FAILED = "anjoman/GET_ADD_ABLE_MEMBER_LIST_FAILED";

export const GET_AVAILABLE_ROLE_LIST_REQUESTED = "anjoman/GET_AVAILABLE_ROLE_LIST_REQUESTED";
export const GET_AVAILABLE_ROLE_LIST_SUCCESS = "anjoman/GET_AVAILABLE_ROLE_LIST_SUCCESS";
export const GET_AVAILABLE_ROLE_LIST_FAILED = "anjoman/GET_AVAILABLE_ROLE_LIST_FAILED";

export const GET_BEST_ACTIVITIES_LIST_REQUESTED = "anjoman/GET_BEST_ACTIVITIES_LIST_REQUESTED";
export const GET_BEST_ACTIVITIES_LIST_SUCCESS = "anjoman/GET_BEST_ACTIVITIES_LIST_SUCCESS";
export const GET_BEST_ACTIVITIES_LIST_FAILED = "anjoman/GET_BEST_ACTIVITIES_LIST_FAILED";

export const SUBMIT_USER_REQUESTED = "anjoman/SUBMIT_USER_REQUESTED";
export const SUBMIT_USER_SUCCESS = "anjoman/SUBMIT_USER_SUCCESS";
export const SUBMIT_USER_FAILED = "anjoman/SUBMIT_USER_FAILED";

export const SAVE_SOCIAL_LINKS_REQUESTED = "anjoman/SAVE_SOCIAL_LINKS_REQUESTED";
export const SAVE_SOCIAL_LINKS_SUCCESS = "anjoman/SAVE_SOCIAL_LINKS_SUCCESS";
export const SAVE_SOCIAL_LINKS_FAILED = "anjoman/SAVE_SOCIAL_LINKS_FAILED";

export const ADD_BULLETIN_REQUESTED = "anjoman/ADD_BULLETIN_REQUESTED";
export const ADD_BULLETIN_SUCCESS = "anjoman/ADD_BULLETIN_SUCCESS";
export const ADD_BULLETIN_FAILED = "anjoman/ADD_BULLETIN_FAILED";

export const SET_BEST_ACTIVITIES = "anjoman/SET_BEST_ACTIVITIES";
export const SET_HAS_MORE_BEST_ACTIVITIES = "anjoman/SET_HAS_MORE_BEST_ACTIVITIES";
export const RESET_SCHOOL = "anjoman/RESET_SCHOOL";
